import styled, { keyframes } from 'styled-components'
import { rgba } from 'polished'
import { Spinner } from '../../../Spinner'
import { Error } from '../Error'
import { Label } from '../Label'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

const animation = {
  duration: '200ms',
  delay: '300ms'
}

export const Field = styled.div<any>`
  position: relative;
  display: block;
  padding-bottom: 32px;

  ${Error} {
    position: absolute;
    left: 0;
    height: 2em;
    bottom: calc(30px - 2em);
    opacity: 0;
    animation: ${fadeIn} ${animation.duration} ${animation.delay} linear forwards;
    ${props => props.hasError && `
      color: ${props.theme.palette.state.danger};
    `}
  }

  ${Spinner} {
    position: absolute;
    right: 10px;
    top: 29px;
    pointer-events: none;
  }

  ${Label} {
    ${props => props.hasError && `
      color: ${props.theme.palette.state.danger};
      transition: color ${animation.duration} ${animation.delay} linear;
    `}
  }

  select {
    transition:
      color ${animation.duration} ${animation.delay} linear,
      border-color ${animation.duration} ${animation.delay} linear,
      box-shadow ${animation.duration} ${animation.delay} linear;
    ${props => props.hasError && `
      color: ${props.theme.palette.state.danger};
      border: 1px solid ${props.theme.palette.state.danger};
    `}

    &:focus {
      ${props => props.hasError && `
        color: ${props.theme.form.passiveColor};
        box-shadow: 0 0 7px ${rgba(props.theme.palette.state.danger, 0.6)};
      `}
    }
  }

  textarea,
  input[type=text],
  input[type=password] {
    transition:
      color ${animation.duration} ${animation.delay} linear,
      border-color ${animation.duration} ${animation.delay} linear,
      box-shadow ${animation.duration} ${animation.delay} linear;
    ${props => props.hasError && `
      color: ${props.theme.palette.state.danger};
      border: 1px solid ${props.theme.palette.state.danger};
    `}

    &:focus {
      ${props => props.hasError && `
        color: ${props.theme.form.fontColor};
        box-shadow: 0 0 7px ${rgba(props.theme.palette.state.danger, 0.6)};
      `}
    }
  }
`
